// "HelloWorld" -> "H"
// "Hello World" -> "HW"
// "Hello World More Words" -> "HW"
const getInitials = (name: string) => {
  return name
    .split(" ", 2) // limit to 2 initials
    .filter(Boolean) // Remove empty strings
    .map((word) => word[0])
    .join("");
};

export { getInitials };
